import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation('offer-package');

  return (
    <footer className="grid print:hidden pt-12 pb-32 md:grid-cols-3 gap-8 bg-[#155f4f]">
      <div></div>

      <div className="flex items-center justify-center">
        <img
          src="https://cdn.mandira-ayurveda.at/images/claim/2024/white_twoline.png"
          alt="Claim"
          width="250px"
          height="200px"
        ></img>
      </div>

      <div className="flex flex-col items-end gap-4 p-8 text-sm text-white font-light">
        <address className="text-right not-italic">
          Ayurveda-Resort MANDIRA GmbH & Co KG
          <br />
          Wagerberg 120
          <br />
          8271 Bad Waltersdorf
          <br />
          Österreich
        </address>

        <a
          href="mailto:info@mandira-ayurveda.at"
          className="underline hover:text-primary-700"
        >
          info@mandira-ayurveda.at
        </a>

        <a href="tel:+4333332801" className="underline hover:text-primary-700">
          +43 3333 2801
        </a>

        <p>© 2025 Ayurveda-Resort MANDIRA GmbH & Co KG</p>

        <a
          href="https://www.mauracher.com"
          className="text-xs no-underline text-[#155f4f] hover:text-[#155f4f] focus:text-[#155f4f]"
        >
          Entwicklet von Mauracher IT-Solutions
        </a>
      </div>
    </footer>
  );
}

export default Footer;
